module.exports = __webpack_public_path__ + "img/INPRG.30c35793.svg";